import React from 'react';
import { connect } from 'react-redux';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { ConnectedQueryParamUpdateProvider } from '../../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { AllSiteUsersSubspaceName, isSiteUsersIntegrationSubspace, SpaceInfo, SpaceItemForNonEntitySpace } from '../../../../spacesPlatform/state/SpaceInfo';
import { ConnectedAllSiteUsersSpace } from './ConnectedAllSiteUsersSpace';

export interface AllSiteUsersSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

interface AllSiteUsersSectionSectionProviderOwnProps extends AllSiteUsersSpaceProviderProps {
  readonly shouldRenderAsSubspace: boolean;
}

interface AllSiteUsersSectionSectionProviderStateProps {
  readonly initialSubspaceName: AllSiteUsersSubspaceName | undefined;
}

type AllSiteUsersSectionSectionProviderProps = AllSiteUsersSectionSectionProviderOwnProps & AllSiteUsersSectionSectionProviderStateProps;

const AllSiteUsersSectionProvider: React.FunctionComponent<AllSiteUsersSectionSectionProviderProps> = (props) => {
  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'siteusers',
    subspaceName: props.initialSubspaceName,
    isKeysetPaginationSpace: FeatureFlags.UserGridInfiniteScrollEnabled
  };
  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllSiteUsersSpace
          {...props}
          siteName={props.siteName}
          urls={props.urls}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

// Preserve the Integration Users subspace across reloadSpace-driven remounts.
const mapStateToProps: MapStateToProps<AllSiteUsersSectionSectionProviderStateProps, AllSiteUsersSectionSectionProviderOwnProps> = (state: AppState) => ({
  initialSubspaceName: FeatureFlags.uiamIntegrationUserLicenseEnabled && isSiteUsersIntegrationSubspace(state.spaceInfo)
    ? 'integrationUsers'
    : undefined,
});

const ConnectedAllSiteUsersSectionProvider = connect(mapStateToProps)(AllSiteUsersSectionProvider);

export const AllSiteUsersSpaceProvider: React.FunctionComponent<AllSiteUsersSpaceProviderProps> = (props) => {
  return <ConnectedAllSiteUsersSectionProvider {...props} shouldRenderAsSubspace={false}/>;
};
